import { useContext } from 'react';
import { APIClientContext } from '@/services/api/provider';

export const useAPIClient = () => {
  const client = useContext(APIClientContext);
  if (!client) {
    throw new Error('useAPIClient must be used within an APIClientProvider');
  }
  return client;
};